
import { Process } from '@/classes/Process'
import { Unit } from '@/classes/Unit'

export class System {
  id: number
  name: string
  description: string
  organisation: string
  category: string
  sizeUnits: string
  size: number
  processes: Array<Process>
  units: Array<Unit>

  constructor (id:number, name:string, description:string, organisation:string, category:string, sizeUnits:string, size:number, units:Array<any>, processes:Array<any>, schedules:Array<any>) {
    this.id = id
    this.name = name
    this.description = description
    this.organisation = organisation
    this.category = category
    this.sizeUnits = sizeUnits
    this.size = size
    this.processes = []
    this.units = []

    processes.forEach(json => {
      this.processes.push(new Process(
        json.paid,
        json.description,
        json.id_unit,
        json.startdate,
        json.enddate,
        json.startdate_with_fallback,
        json.enddate_with_fallback,
        json.startdate_pre,
        json.enddate_pre,
        schedules
      ))
    })

    units.forEach(json => {
      this.units.push(new Unit(
        json.id,
        json.name,
        json.description,
        json.manufacturer,
        json.model,
        json.application,
        json.category,
        json.size,
        json.size_unit
      ))
    })
  }
}
